import React, { type SFC } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import type { List } from "src/lists/objects/List";
import { LISTS_VIEW_PATH } from "src/lists/views/ListsView";
import {
  type IRaangeLabelProps,
  RaangeLabel,
} from "src/shared/components/RaangeLabel";
import FormattedInstant from "src/shared/formatters/FormattedInstant";
import type ILinkable from "src/shared/formatters/ILinkable";
import { StatusFormatter } from "src/shared/formatters/StatusFormatter";

export interface IListsLabelProps
  extends Omit<IRaangeLabelProps, "fa">,
    ILinkable {}

export const ListsLabel: SFC<IListsLabelProps> = (props) => {
  const { hasLink = false } = props;
  const label = (
    <RaangeLabel fa="list-alt" {...props}>
      <FormattedMessage id="lists" />
    </RaangeLabel>
  );
  if (hasLink) {
    return <Link to={LISTS_VIEW_PATH}>{label}</Link>;
  } else {
    return label;
  }
};

export interface IListFormatterProps extends Omit<IRaangeLabelProps, "fa"> {
  children: List;
}

export const ListFirstCreated: SFC<IListFormatterProps> = (props) => {
  const { children: list } = props;
  return <FormattedInstant value={list.firstCreated} />;
};

export const ListStatus: SFC<IListFormatterProps> = (props) => {
  const { children: list } = props;
  switch (list.listStatus) {
    case "READY":
      return (
        <StatusFormatter status="active">
          <FormattedMessage id="lists.status.ready" />
        </StatusFormatter>
      );
    case "IN_PROGRESS":
      return (
        <StatusFormatter status="warning">
          <FormattedMessage id="lists.status.in_progress" />
        </StatusFormatter>
      );
    case "FAILED":
      return (
        <StatusFormatter status="inactive">
          <FormattedMessage id="lists.status.failed" />
        </StatusFormatter>
      );
  }
};

export const ListCreate: SFC<Omit<IRaangeLabelProps, "fa">> = (props) => {
  return (
    <RaangeLabel fa="plus" {...props}>
      <FormattedMessage id="lists.create" />
    </RaangeLabel>
  );
};
